import { accessRole } from "../../../../helpers/access_role"
import classnames from 'classnames'
import React, { Fragment, useState, useRef, useEffect } from "react"
import apiResponse from "../../../../services/apiResponse"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Input
} from "reactstrap"


import moment from "moment"
import IndexBloc from "./Blocs/IndexBlock"

import CustomSelect from "../../GlobalComponents/CustomSelect"
import Select from "react-select"

import TableActiveComponent from './Components/TableActiveComponent'
import TableSecondComponent from "./Components/TableSecondComponent"
import TableThirdComponent from "./Components/TableThirdComponent"

const createYearOption = (startYear = 2000) => {
  var currentYear = new Date().getFullYear(), years = [];
    startYear = startYear || 1980;  
    while ( startYear <= currentYear ) {
        var newObj = {};
        var year = startYear++;
        newObj["label"] = year;
        newObj["value"] = year;
        years.push(newObj);
    }   
    return years;
}
  
const createMonthOptions = () => {
    var months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];

    return months.map(function(month, i) {
        var newObj = {};
        newObj["label"] = month;
        newObj["value"] = ++i;

        return newObj;
    });
}
var reformatOptions = function (raw, label, value) {
    return raw.map(function (data) {
        var newObj = {};
        newObj["label"] = data[label];
        newObj["value"] = data[value];

        return newObj;
    });
};    
const IndexView = (props) => {
    
    let indexBloc = new IndexBloc();
    const [activeTab, setactiveTab] = useState("1")    
    const activeRef = useRef();
    const secondRef = useRef();
    
    // Select
    const [yearOptions, setYearOptions] = useState(createYearOption(new Date().getFullYear() - 30));
    const [monthOptions, setMonthOptions] = useState(createMonthOptions());
    
    // Filter
    const [nip, setNip] = useState('')
    const [name, setName] = useState('')
    const [year, setYear] = useState(new Date().getFullYear())
    const [month, setMonth] = useState(moment().format('M'))
    const [work_unit_uuid_echelon_1, setwork_unit_uuid_echelon_1] = useState('')
    const [work_unit_uuid_echelon_2, setwork_unit_uuid_echelon_2] = useState('')

    const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));
    
    let additionalFilter = {
        nip: nip,
        name: name,
        year: year,
        month: month,
        start_date: startDate,
        end_date: endDate,
        work_unit_uuid_echelon_1:work_unit_uuid_echelon_1,
        work_unit_uuid_echelon_2:work_unit_uuid_echelon_2
    };
    
    const toggle = (tab) => {
        if (activeTab !== tab) {
            setactiveTab(tab)
        }
    }

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadSecondRef = () => secondRef.current.setTokenAPI()
    const exportketidakhadiranActiveRef = () => activeRef.current.exportKetidakhadiranExcel()
    const [optionUnits, setOptionUnits] = useState([]);
    const [optionUnits2, setOptionUnits2] = useState([]);
    const [optionUnitsAll, setOptionUnitsAll] = useState([]);
    const [selUnit, setselUnit] = useState("")
    const [loading, setLoading] = useState(false)

    function handleButtonSearch() {
        reloadActiveRef()
        reloadSecondRef()
    }
    
    function handleButtonReset() {
        setNip('');
        setName('');
        reloadActiveRef()
    }
    function handleButtonKetidakhadiranExport(){
        exportketidakhadiranActiveRef();
    }
    function handle_onchange_unit(selectedOption){
        indexBloc.workUnitChannel2.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response.result
                        setOptionUnits2(
                            reformatOptions(response, 'work_unit_name_tabs', 'work_unit_uuid')
                        )
                        console.log(optionUnits2)
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        indexBloc.fetchWorkUnit2({ parent_uuid: selectedOption.value });
    }
    useEffect(() => {
        indexBloc.workUnitChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.LOADING:
                    setLoading(true); // Meaktifkan loading
                    break
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response.result
                        setOptionUnits(
                            reformatOptions(response, 'work_unit_name_tabs', 'work_unit_uuid')
                        )
                    }
                    break
                case apiResponse.ERROR:
                    setLoading(false); // Menonaktifkan loading jika terjadi error

                    break
                default:
                    break
            }
        })
        indexBloc.fetchWorkUnit({})
        indexBloc.workUnitAllChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.LOADING:
                    setLoading(true); // Meaktifkan loading
                    break
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response.result
                        setOptionUnitsAll(
                            reformatOptions(response, 'work_unit_name_tabs', 'work_unit_uuid')
                        )
                    }
                    break
                case apiResponse.ERROR:
                    setLoading(false); // Menonaktifkan loading jika terjadi error

                    break
                default:
                    break
            }
        })
        indexBloc.fetchWorkUnitAll({})

    }, []);
    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">
                        
                        <Card>
                            <CardBody>
                                <div className="float-end">
                                </div>
                                <CardTitle>List Data Pegawai</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Daftar Seluruh Pegawai
                                </CardSubtitle>
                                <hr />
                                {/* <Row className="mb-3">
                                    <label className="col-md-2">
                                        Unit Echelon-1
                                    </label>
                                    <Col md="3">
                                    <Select
                                        name="work_unit_uuid_echelon_1"
                                        onChange={(selectedOption) => {
                                            setLoading(true); // Mengaktifkan loading saat memilih unit
                                            setwork_unit_uuid_echelon_1(selectedOption.value);
                                            handle_onchange_unit(selectedOption);
                                            indexBloc.fetchWorkUnit2({ parent_uuid: selectedOption.value })
                                                .finally(() => setLoading(false)); // Menonaktifkan loading setelah selesai
                                        }}
                                        required="required"
                                        options={optionUnits}
                                        classNamePrefix="select2-unit"
                                    />
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <label className="col-md-2">
                                        Unit Echelon-2
                                    </label>
                                    <Col md="3">
                                    <Select
                                        name="work_unit_uuid_echelon_2"
                                        onChange={(selectedOption) => {
                                            setwork_unit_uuid_echelon_2(selectedOption.value);
                                        }}
                                        // required="required"
                                        options={optionUnits2}
                                        classNamePrefix="select2-unit"
                                    />
                                    </Col>
                                </Row>
                               
                                <Row className="mb-3">
                                    <Col md="2"></Col>
                                    <Col md="10">
                                        <Button 
                                            color="primary" 
                                            type="button"
                                            onClick={() => {
                                                handleButtonSearch()
                                            }}
                                        >
                                            <i className="uil-search-alt"></i> Cari
                                        </Button>
                                        {' '}
                                        <Button 
                                          color="warning" 
                                          type="button"
                                          onClick={() => {
                                              handleButtonReset()
                                          }}>
                                            <i className="uil-refresh"></i> Reset
                                        </Button>
                                        {' '}
                                    </Col>
                                </Row> */}

                                {/* <hr /> */}

                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: activeTab === "1",
                                            })}
                                            onClick={() => {
                                                toggle("1")
                                            }}
                                        >
                                            <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                            <span className="d-none d-sm-block">Usulan Mutasi</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                            active: activeTab === "2",
                                                })}
                                            onClick={() => {
                                                toggle("2")
                                            }}
                                        >
                                            <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                            <span className="d-none d-sm-block">Proses Mutasi</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                            active: activeTab === "3",
                                                })}
                                            onClick={() => {
                                                toggle("3")
                                            }}
                                        >
                                            <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                            <span className="d-none d-sm-block">Riwayat Mutasi</span>
                                        </NavLink>
                                    </NavItem>
                                </Nav>

                                <TabContent activeTab={activeTab} className="p-3 text-muted">
                                    <TabPane tabId="1">
                                        <TableActiveComponent ref={activeRef} handleInactiveSuccess={reloadActiveRef} additionalFilter={additionalFilter} wuall = {optionUnitsAll}/>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <TableSecondComponent ref={activeRef} handleInactiveSuccess={reloadActiveRef} additionalFilter={additionalFilter} wuall = {optionUnitsAll}/>
                                        {/* <TableSecondComponent ref={secondRef} /> */}
                                    </TabPane>
                                    <TabPane tabId="3">
                                        <TableThirdComponent ref={activeRef} handleInactiveSuccess={reloadActiveRef} additionalFilter={additionalFilter} wuall = {optionUnitsAll}/>
                                        {/* <TableSecondComponent ref={secondRef} /> */}
                                    </TabPane>
                                </TabContent>
                                
                            </CardBody>
                        </Card>
                        
                       
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView